<template>
  <router-link-modified v-if="isLogged"
                        :to="{name: 'credits-get'}"
                        class="base-btn base-btn--blue">
    <span class="base-btn__text">{{ $tCredits('Get the credit') }}</span>
    <BaseSvg name="ico-arrow-light"/>
  </router-link-modified>
  <router-link-modified v-else
                        :to="{name: 'auth', query: {'for-credit': 'true', redirect}}"
                        class="base-btn base-btn--blue">
    <span class="base-btn__text">{{ $tCredits('Get the credit') }}</span>
    <BaseSvg name="ico-arrow-light"/>
  </router-link-modified>
</template>

<script>
  export default {
    name: 'CreditsPageAdvantagesBtn',
    computed: {
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
      redirect() {
        const lang = this.$route.params.lang
        let name = 'credits-get'

        if (
            (!lang || lang === 'ua')
        ) {
          name += '-double'
        }
        const route = this.$router.matcher.match({name, params: {lang}})
        return route.fullPath
      }
    }
  }
</script>

<style lang="less">

</style>